<jhi-alert-overlay />
<div
    id="page-wrapper"
    class="page-wrapper"
    [ngClass]="{ 'no-padding': isShownViaLti }"
    [ngStyle]="{ 'overflow-y': !isTestRunExam && isExamStarted ? 'hidden' : 'auto' }"
    cdkScrollable
>
    <jhi-page-ribbon />
    @if (showSkeleton && !isShownViaLti) {
        <div class="sticky-top-navbar">
            <router-outlet name="navbar" />
        </div>
    }
    @if (showSkeleton) {
        <div>
            <div [ngClass]="{ 'course-overview px-3': isCourseOverview }">
                <router-outlet />
            </div>
        </div>
    } @else {
        <router-outlet />
    }
    <jhi-course-notification-popup-overlay />
    @if (showSkeleton && !isShownViaLti) {
        @if (isTestRunExam || !isExamStarted) {
            <jhi-footer />
        }
    }
</div>
